import type { NavigationGuardNext, RouteLocationNormalized } from "vue-router";

export default async function studyAccessPageMiddleware(
   to: RouteLocationNormalized,
   from: RouteLocationNormalized,
   next: NavigationGuardNext
) {
   /*
      If a study requires an access code, one of the Flow middleware checks will be that the code has been entered.
      If the PPT hasn't entered a code, they will get redirected to the StudyAccessPage which also has it's own (this) middleware.
      The middleware here checks that the PPT has been redirected from the Flow page.
   */
   if (to.redirectedFrom?.name !== "flow") {
      return next({ name: "study", params: { key: to.params.key, locale: to.params?.locale } });
   } else {
      return next();
   }
}
